// TODO: Remove
export const getStudioStyling = () => {
  return {
    colors: {
      borderTop: '#0e106a'
    }
  };
};
//# sourceMappingURL=getStudioStyling.js.map